import { Box, SvgIcon } from '@mui/material';
import { green } from '@mui/material/colors';

export const ActiveLocationIcon = (props) => {
  return (
    <Box
      sx={{
        width: props.sx?.width || 14,
        height: props.sx?.height || 14,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: green[600],
        borderRadius: '50%',
      }}
    >
      <SvgIcon {...props}>
        <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.99992 2.7619C5.97278 2.7619 4.33325 4.40143 4.33325 6.42857C4.33325 9.17857 7.99992 13.2381 7.99992 13.2381C7.99992 13.2381 11.6666 9.17857 11.6666 6.42857C11.6666 4.40143 10.0271 2.7619 7.99992 2.7619ZM7.99992 7.73809C7.27706 7.73809 6.6904 7.15143 6.6904 6.42857C6.6904 5.70571 7.27706 5.11904 7.99992 5.11904C8.72278 5.11904 9.30944 5.70571 9.30944 6.42857C9.30944 7.15143 8.72278 7.73809 7.99992 7.73809Z"
            fill="white"
          />
        </svg>
      </SvgIcon>
    </Box>
  );
};
